import axios from 'axios'
import Immutable from 'immutee'

import { getApiSeoUrl } from '../utils/utils'

export const FETCH_SEO_DIRECTIVES = 'buyer/seoDirectives/FETCH_SEO_DIRECTIVES'
export const FETCH_SEO_DIRECTIVES_FAILURE =
  'buyer/seoDirectives/FETCH_SEO_DIRECTIVES_FAILURE'

const initialState = {
  fetched: false,
  result: {},
  error: null,
}

export default function reducer(state = initialState, action) {
  const immutable = Immutable(state)
  switch (action.type) {
    case FETCH_SEO_DIRECTIVES:
      return immutable.set('result', action.payload).set('fetched', true).done()

    case FETCH_SEO_DIRECTIVES_FAILURE:
      return immutable
        .set('error', action.payload)
        .set('result', {})
        .set('fetched', false)
        .done()
    default:
      return state
  }
}

export function fetchSeoDirectives(idAnuncio, vehicleType) {
  const apiSeoUrl = getApiSeoUrl()
  const url = apiSeoUrl && `${apiSeoUrl}anuncios/${idAnuncio}/seo-directives`
  const tipoVeiculo = vehicleType === 'bike' ? 'moto' : 'carro'
  const requestConfig = {
    params: { tipoVeiculo },
  }

  return dispatch => {
    if (!url) {
      dispatch({
        type: FETCH_SEO_DIRECTIVES,
        payload: { anuncioId: idAnuncio, robots: 'noindex,nofollow' },
      })
      return Promise.resolve()
    }

    return axios
      .get(url, requestConfig)
      .then(res => {
        dispatch({
          type: FETCH_SEO_DIRECTIVES,
          payload: res.data,
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_SEO_DIRECTIVES_FAILURE,
          payload: err.stack,
        })
      })
  }
}
